import React from "react";
import cx from "classnames";

const ToggleSwitch = ({ checked, onChange, label }) => (
  <div className="toggle-switch" onClick={() => onChange(!checked)}>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className={cx("toggle-switch__track", { "toggle-switch__track--on": checked })}
    >
      <span className="toggle-switch__knob" />
    </button>
    {label && <span className="toggle-switch__label">{label}</span>}
  </div>
);

export default ToggleSwitch;
